import { TypographyProps } from "@material-ui/core";

export interface AlmeLiveChatBannerConfig {
    liveChatBanner: {
        joined: {
            main: {
                text: string;
                variant?: TypographyProps['variant'];
            };
            sub: {
                text: string;
                variant?: TypographyProps['variant'];
            };
        };
        ended: {
            main: {
                text: string;
                variant?: TypographyProps['variant'];
            };
            sub: {
                text: string;
                variant?: TypographyProps['variant'];
            };
            reason: {
                defaultReason: string;
                text: string;
                variant?: TypographyProps['variant'];
            };
        };
        left: {
            text: string;
            variant?: TypographyProps['variant'];
        };
        defaultRepName: string;
    };
}

/**
 * This is the baseline live chat banner config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeLiveChatBannerConfig = {
    liveChatBanner: {
        joined: {
            main: {
                text: 'Connected To',
            },
            sub: {
                text: 'Customer Service Representative: ',
            },
        },
        left: {
            text: ' has left the conversation',
        },
        ended: {
            main: {
                text: 'Returning To',
            },
            sub: {
                text: 'Virtual Assistant',
            },
            reason: {
                defaultReason: 'System',
                text: ' Ended Live Chat',
            },
        },
        defaultRepName: 'Operator',
    },
};

export default defaultConfig;